import React from 'react';
import { EntityTechdocsContent } from '@backstage/plugin-techdocs';
import { TechDocsAddons } from '@backstage/plugin-techdocs-react';
import { ReportIssue } from '@backstage/plugin-techdocs-module-addons-contrib';
import { Progress, EmptyState } from '@backstage/core-components';
import LockIcon from '@material-ui/icons/Lock';
import { useOpenFgaPermission } from '../../../../hooks/useOpenFgaPermission';

/**
 * EntityTechdocsContent with permission check
 * Only users with 'can_manage_config' relation on the component can access this
 * Note: The tab visibility is controlled by TabPermissionGuard in the overview
 */
export const ProtectedDocsContent: React.FC = () => {
  const { allowed, loading, error } = useOpenFgaPermission('can_manage_config');

  if (loading) {
    return <Progress />;
  }

  if (error) {
    return (
      <EmptyState
        missing="info"
        title="Error al verificar permisos"
        description={`No se pudieron verificar tus permisos: ${error.message}`}
      />
    );
  }

  if (!allowed) {
    return (
      <EmptyState
        missing="data"
        title="Acceso Denegado"
        description="No tienes permisos para acceder a la documentación de este componente. Solo usuarios con rol JP o DevOps pueden acceder a esta función."
        action={<LockIcon style={{ fontSize: 64, color: '#999' }} />}
      />
    );
  }

  return (
    <EntityTechdocsContent>
      <TechDocsAddons>
        <ReportIssue />
      </TechDocsAddons>
    </EntityTechdocsContent>
  );
};
